import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { components } from 'react-select';
import DSPopper, { PopperPositions } from '@elliemae/ds-popper';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import Content from './Content.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'prop-types';

var TriggerComponent = aggregatedClasses('div')('combobox-trigger', null);

var SelectMenu = function SelectMenu(props) {
  var _props$selectProps = props.selectProps,
      inlineMenu = _props$selectProps.inlineMenu,
      bounds = _props$selectProps.selectMeasure.bounds,
      expandMenuToContainer = _props$selectProps.expandMenuToContainer,
      expandMenuOutsideContainer = _props$selectProps.expandMenuOutsideContainer,
      zIndex = _props$selectProps.zIndex;

  if (inlineMenu) {
    return /*#__PURE__*/React.createElement(components.Menu, props);
  }

  var styleMenu = expandMenuToContainer ? {
    width: bounds.width
  } : {};

  if (expandMenuOutsideContainer) {
    styleMenu.width = 'auto';
  }

  return /*#__PURE__*/React.createElement(DSPopper, {
    contentComponent: /*#__PURE__*/React.createElement(Content, _extends({}, props, {
      styleMenu: styleMenu
    })),
    isOpen: true,
    placement: PopperPositions.BOTTOM_START,
    preventOverflow: /*#__PURE__*/React.createElement(TriggerComponent, null),
    showArrow: false,
    triggerComponent: /*#__PURE__*/React.createElement(TriggerComponent, null),
    zIndex: zIndex
  });
};

export default SelectMenu;
//# sourceMappingURL=SelectMenu.js.map
